import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import deleteListing from '../../models/Integration/deleteListing'

function* disconnectListing(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.DeleteListing)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, deleteListing)),
    ])

    yield Effects.put({
      type: IntegrationAction.AcceptDeleteListing,
      payload: {
        id_room: action.payload.id_room,
        id_listing: action.payload.id_listing,
      },
    })

    yield call(service, action.payload.id_room, action.payload.id_listing)
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(IntegrationAction.DeleteListing, disconnectListing)
}
